export default __webpack_public_path__ + "static/circle-deco-f697c002cd57ae2dc665d324d9c41ffa.png";